function CancelSvg() {
  return (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Group">
          <path id="Vector" d="M3.59863 3.40379L12.7911 12.5963" stroke="#CA0202" strokeWidth="1.95001" strokeLinecap="round"/>
          <path id="Vector_2" d="M3.59863 12.5962L12.791 3.40383" stroke="#CA0202" strokeWidth="1.95001" strokeLinecap="round"/>
        </g>
      </svg>
  )
};

export default CancelSvg;